import {useApi} from "../../../hooks/useApi";
import {useCallback, useState} from "react";
import {Query, QueryResult} from "material-table";
import _ from "lodash";
import {makeQueryResult} from "../../root/transaction/tabs/transfers/hooks/useTransfersLoader";
import {UserProfile} from "../../../api/api";


export interface UserRow {
  id: string,
  email: string,
  role: string,
  relatedEntityId?: number
}

function user2row(user: UserProfile): UserRow {
  return {
    id: user.id,
    email: user.username,
    role: user.role,
    relatedEntityId: user.relatedEntityId
  }
}

export function useUserLoader() {
  const {api} = useApi(),
    [isLastPage, setLastPage] = useState(true);

  const loader = useCallback(async (q: Query<UserRow>): Promise<QueryResult<UserRow>> => {
    const offset = q.page * q.pageSize;
    let req: any = {
      offset,
      limit: q.pageSize,
    }
    try {
      const res = await api.getUsers(req);
      if (res.status === 200) {
        const userRows = _.map(res.body.items, user2row)
        setLastPage(!res.body.paginationMetadata.hasNextPage)
        return makeQueryResult(userRows, q.page, offset+userRows.length)
      }
    } catch (e) {
      console.error(e)
    }
    return makeQueryResult()
  }, [api]);

  return {loader, isLastPage}
}
